import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import Loader from './Loader/Loader'
import TapTop from './TapTop/TapTop'
import Footer from './Footer/Footer'
import Sidebar from './Sidebar/Sidebar'
import Header from './Header/Header'
import ThemeCustomizer from './ThemeCustomizer/ThemeCustomizer'
import { useAppDispatch, useAppSelector } from '../ReduxToolkit/Hooks'
import { setToggleSidebar } from '../ReduxToolkit/Reducers/LayoutSlice'
import { setLayout } from '../ReduxToolkit/Reducers/ThemeCustomizerSlice'

export default function Layout() {
    const { layout } = useAppSelector((state) => state.themeCustomizer)
    const dispatch = useAppDispatch()
    const compactSidebar = () => {
        let windowWidth = window.innerWidth;
        if (layout === "compact-wrapper") {
            if (windowWidth < 1200) {
                dispatch(setToggleSidebar(true))
            }
            else {
                dispatch(setToggleSidebar(false))
            }
        } else if (layout === "horizontal-wrapper") {
            if (windowWidth < 992) {
                dispatch(setToggleSidebar(true))
                dispatch(setLayout("compact-wrapper"))
            }
            else {
                dispatch(setToggleSidebar(false))
                dispatch(setLayout("horizontal-wrapper"))
            }
        }
    };
    useEffect(() => {
        compactSidebar();
        window.addEventListener("resize", () => {
            compactSidebar();
        });
    }, [layout]);
    return (
        <>
            <Loader />
            <TapTop />
            <div className={`page-wrapper ${layout}`}>
                <Header />
                <div className="page-body-wrapper">
                    <Sidebar />
                    <Outlet />
                    <Footer />
                </div>
            </div>
            <ThemeCustomizer />
        </>
    )
}
